import React, { useState, useContext, useEffect } from 'react'
import {
  Form,
  Switch,
  Divider,
} from 'antd'

import { CreateMemberLyfeContext } from '../../../../../../..'
// import TooltipInfo from '../../../../../../../../CreateEventV2/TooltipInfo'

import PassForm from './PassForm'
import './index.styl'

const { Item, List } = Form

const Passes = ({ currentPageDetails }) => {
  const { form } = useContext(CreateMemberLyfeContext)

  const [passesSwitch, setPassesSwitch] = useState(false)
  const [passes, setPasses] = useState(form.getFieldValue('passes') || [])
  // const mobile = window.innerWidth <= 730
  // const tooltipTitle = `Charity Raffles are limited to $30,000 in total ticket sales and $100 max price per ticket

  // Ticket Lyfe charges for Charity Raffle Tickets are $1 for Raffles priced up to $50 and $2 for higher priced Raffle Tickets

  // Do not pick Charity Raffles if you are doing a regular event with Random Draw Prizes--Because you can do a Random Draw on ANY Ticket Lyfe Event, the Charity Raffle limits above will not apply, and Ticket Lyfe treat your event as an ordinary Ticketed Event`

  // const additionalTooltip = (
  //  <TooltipInfo
  //    className='tooltipTitle'
  //    text={mobile ? '' : 'Additional info'}
  //    info={tooltipTitle}
  //  />
  // )

  useEffect(() => {
    if (!!currentPageDetails?.passes?.length) {
      setPassesSwitch(true)
      setPasses(currentPageDetails.passes)
    }
  }, [currentPageDetails])

  useEffect(() => {
    if (!passes.length) {
      setPassesSwitch(false)
      form.setFieldsValue({
        passesSwitch: false,
      })
    }
  }, [passes, form])

  const handleSwitchChange = checked => {
    setPassesSwitch(checked)
    if (checked && !passes.length) {
      const newPasses = [{}]
      setPasses(newPasses)
      form.setFieldsValue({
        passes: newPasses,
      })
    }
  }

  const getPassesData = idx => {
    return passes[idx]
  }

  return (
    <div className='sessionAndPassesWrapper'>
      <div className={passesSwitch ? 'betweenWraper active' : 'betweenWraper'}>
        <div className='radioWrapper'>
          <Item style={{ marginBottom: 0 }} name='passesSwitch' valuePropName='checked' className='item'>
            <Switch onChange={handleSwitchChange} />
          </Item>
          <div className='text'>Passes</div>
        </div>
        {/* <div className='tooltipWrapper'>{additionalTooltip}</div> */}
      </div>
      {passesSwitch && (
        <List name='passes'>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, fieldKey, ...restField }) => (
                <PassForm
                  currentPageDetails={currentPageDetails}
                  form={form}
                  categoryData={getPassesData(fieldKey)}
                  key={key}
                  name={name}
                  fieldKey={fieldKey}
                  onRemove={index => {
                    remove(index)
                    const updatedPasses = form.getFieldValue('passes')
                    setPasses(updatedPasses)
                    if (updatedPasses.length === 0) {
                      form.setFieldsValue({
                        passesSwitch: false,
                      })
                    }
                  }}
                  {...restField}
                />
              ))}
              <div
                id='addCategory'
                className='addCategoryBtn'
                onClick={() => {
                  add()
                  const updatedPasses = form.getFieldValue('passes')
                  setPasses(updatedPasses)
                }}
              >Add Another Pass
              </div>
            </>
          )}
        </List>
      )}
      <Divider />
    </div>
  )
}

export default Passes
